{
  "dateFormat": "{{month}} {{date}}, {{year}}"
}
